import styled from "styled-components";

import { CompanyLogo } from "../components/CompanyLogo";
import { CompanyShortDescription } from "../components/CompanyShortDescription";
import { StatusTags } from "../components/StatusTags";
import { DesktopContentProps } from "../DesktopContent";
import { CompanyMission } from "../../../../components/CompanyMission";
import { CompanyProfileButton } from "../components/CompanyProfileButton";

import { SizeAndSector } from "./SizeAndSector";
import { SalaryTechExperienceLocation } from "./SalaryTechExperienceLocation";
import { MobileOnly } from "./JobSection";

import { VerticalSpacing, media } from "@otta/design";
import { useVariant } from "@otta/search/hooks/unleash";
import { Experiment } from "@otta/search/constants/experiments";

const TopCardSectionRight = styled(VerticalSpacing)`
  flex-basis: 0;
  flex-grow: 1;
  display: flex;
  flex-direction: column;

  ${media({ to: "tablet" }, "screen")`
    display: none;
  `}
`;

export const CompanySection = ({
  job,
  user,
}: Pick<DesktopContentProps, "job" | "user">): React.ReactElement => {
  const { variant } = useVariant(Experiment.MinimisedJobCardV2, {
    amplitude: true,
  });

  if (variant === "v1") {
    return (
      <>
        <TopCardSectionRight data-testid="company-section">
          <CompanyLogo company={job.company} />
          <CompanyShortDescription company={job.company} />
          <SizeAndSector company={job.company} user={user} />
          <StatusTags company={job.company} job={job} />
          <CompanyProfileButton company={job.company} section="job-card-hero" />
        </TopCardSectionRight>
        <MobileOnly>
          <SalaryTechExperienceLocation job={job} user={user} />
        </MobileOnly>
        <MobileOnly>
          <SizeAndSector company={job.company} user={user} />
        </MobileOnly>
      </>
    );
  }

  return (
    <>
      <TopCardSectionRight data-testid="company-section">
        <CompanyLogo company={job.company} />
        <CompanyShortDescription company={job.company} />
        <SizeAndSector company={job.company} user={user} />
        <StatusTags company={job.company} job={job} />
      </TopCardSectionRight>
      <MobileOnly>
        <SalaryTechExperienceLocation job={job} user={user} />
      </MobileOnly>
      <MobileOnly>
        <SizeAndSector company={job.company} user={user} />
      </MobileOnly>
      <MobileOnly>
        <CompanyMission company={job.company} />
      </MobileOnly>
    </>
  );
};
